<template>
  <div class="customized-goods">
    <div :class="`goods-list ${classNameType}`">
      <div
        class="goods-item"
        v-for="(item, index) in goodsList"
        :key="index"
        @click="productDetail(item.product.publishId)"
      >
        <img class="img" :src="item.product.pic" alt="" />
        <div class="goods-info">
          <div class="title">
            <span class="free-tag" v-if="item.product.freeTerm">免息</span>
            {{ item.product.name }}
          </div>

          <div
            class="tag"
            v-if="checkChannelPromotionExist(item) || item.shopPromotionBest"
            v-show="checkChannelPromotionExist(item)"
            style="margin-right: 5px"
          >
            {{ getChannelPromotionDesc(item) }}
          </div>
          <div
            class="tag"
            v-if="checkChannelPromotionExist(item) || item.shopPromotionBest"
            v-show="item.shopPromotionBest"
          >
            {{ getShopPromotionDesc(item) }}
          </div>
          <div class="price" v-if="item.product.freeTerm">
            <span class="symbol">￥</span>
            <span class="num">{{ item.product.freePrice }}</span>
            <span class="text">/期起</span>
            <div class="sum-price" v-if="setData.showType != 'scroll'">
              ￥{{ item.product.price }}
            </div>
          </div>
          <div
            class="sum-price"
            :style="`margin-top: ${item.product.freeTerm ? 0 : 8}px`"
            v-if="setData.showType == 'scroll'"
          >
            ￥{{ item.product.price }}
          </div>
          <div
            class="sum-price"
            :style="`margin-top: ${setData.showType != 'scroll' ? 8 : 0}px`"
            v-else-if="!item.product.freeTerm"
          >
            ￥{{ item.product.price }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { post } from 'api/post'
export default {
  name: 'Goods',
  components: {},
  props: {
    contentData: {
      type: Array,
      default: () => [],
    },
    setData: {
      type: Object,
      default: () => {
        return {
          showType: 'scroll', // 展示方式 one two scroll
          topSpace: 'medium', // 上边距 small medium big
          bottomSpace: 'medium', // 下边距 small medium big
        }
      },
    },
  },
  data() {
    return {
      classNameType: `showType-${this.setData.showType} topSpace-${this.setData.topSpace} bottomSpace-${this.setData.bottomSpace}`,
      goodsList: [],
      categoryCodeList: [],
      productIdList: [],
    }
  },
  watch: {
    contentData: {
      handler() {
        console.log('************')
        console.log('this.contentData')
        console.log(this.contentData[0])
        if (this.contentData[0].tab == 'designatedGoods') {
          let list = this.contentData[0].list.map((goods) => {
            return goods.id
          })
          this.productIdList = list
          this.categoryCodeList = []
        } else if (this.contentData[0].tab == 'designatedClass') {
          this.productIdList = []
          this.categoryCodeList = this.contentData[0].classIds.slice(-1)
        } else if (this.contentData[0].tab == 'allGoods') {
          this.productIdList = []
          this.categoryCodeList = []
        }
        console.log('监听完毕，')
        this.init()
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    // this.init()
  },
  methods: {
    init() {
      console.log('开始init')
      console.log(this.goodsList)
      console.log(this.categoryCodeList)
      let that = this
      post('product/search', {
        channelCode: 'JH001',
        categoryCodeList: this.categoryCodeList,
        productIdList: this.productIdList,
        pageSize: 200,
      }).then((res) => {
        console.log(res)
        // this.goodsList = res.data.list
        let resData = JSON.parse(JSON.stringify(res.data))

        if (!resData.list) {
          this.$set(resData, 'list', [])
        }

        resData.list.forEach((item) => {
          if (item.product.freeTerm) {
            let freeTermArray = item.product.freeTerm.split(',')
            let free = freeTermArray[freeTermArray.length - 1]

            item.product.freePrice = that.$roundHalfUp(
              that.$divide(item.product.price, free),
              2
            )
          }
          item.product.price = that.$accounting.toFixed(item.product.price, 2)
        })
        this.goodsList = resData.list
      })
    },
    productDetail(publishId) {
      this.$router.push({
        path: '/productDetail',
        query: { publishId: publishId },
      })
    },
    checkChannelPromotionExist(data) {
      if (!data.channelPromotionList || data.channelPromotionList.length < 1) {
        return false
      }

      return data.channelPromotionList.find((i) => i.type == '1')
    },
    getChannelPromotionDesc(data) {
      if (!data.channelPromotionList || data.channelPromotionList.length < 1) {
        return ''
      }

      let promotion = data.channelPromotionList.find((i) => i.type == '1')

      if (promotion) {
        return promotion.limitAmt + '%积分最高抵扣'
      }

      return ''
    },
    getShopPromotionDesc(data) {
      if (!data.shopPromotionBest) {
        return ''
      }

      if (data.shopPromotionBest.type == '1') {
        return (
          '满' +
          data.shopPromotionBest.minPoint +
          '减' +
          data.shopPromotionBest.amount
        )
      } else if (data.shopPromotionBest.type == '2') {
        return (
          '满' +
          data.shopPromotionBest.minPoint +
          '打' +
          data.shopPromotionBest.amount / 10 +
          '折'
        )
      }

      return ''
    },
  },
}
</script>

<style lang="less" scoped>
.customized-goods {
  font-size: 0;
  width: 100%;
  .goods-list {
    box-sizing: border-box;
    .goods-item {
      background: #ffffff;
      border-radius: 10px;
      .img {
        width: 90px;
        height: 90px;
        border-radius: 8px;
      }
      .goods-info {
        box-sizing: border-box;
        width: 100%;
        .title {
          width: 100%;
          max-height: 36px;
          font-size: 13px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 18px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          .free-tag {
            padding: 1px 4px;
            background: #ff4e4e;
            border-radius: 4px;
            font-size: 11px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #ffffff;
          }
        }
        .tag {
          margin-top: 4px;
          display: inline-block;
          padding: 2px 4px;
          background: rgba(255, 78, 78, 0.06);
          border-radius: 4px;
          font-size: 11px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #ff4e4e;
        }
        .price {
          position: relative;
          .symbol {
            font-size: 15px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #ff4e4e;
          }
          .num {
            font-size: 20px;
            font-family: 'DINA';
            font-weight: bold;
            color: #ff4e4e;
          }
          .text {
            font-size: 12px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #333333;
          }
          .sum-price {
            position: absolute;
            right: 0;
            bottom: 0;
            font-size: 11px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #cccccc;
          }
        }
        .sum-price {
          font-size: 11px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #cccccc;
        }
      }
    }
  }
  .showType-one {
    .goods-item {
      margin: 0 auto 10px;
      width: 355px;
      height: 110px;
      padding: 10px;
      box-sizing: border-box;
      display: flex;
      .img {
        width: 90px;
        height: 90px;
        border-radius: 8px;
      }
      .goods-info {
        margin-left: 10px;
        flex: 1;
        .price {
          margin-top: 9px;
        }
      }
    }
    .goods-item:last-child {
      margin: 0 auto;
    }
  }
  .showType-two {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 0 5px;
    .goods-item {
      margin: 0 5px;
      width: 172px;
      height: 280px;

      .img {
        width: 172px;
        height: 172px;
        border-radius: 10px 10px 0px 0px;
      }
      .goods-info {
        padding: 8px 10px;
        .price {
          margin-top: 5px;
        }
        .sum-price {
          margin-top: 8px;
        }
      }
    }
    .goods-item {
      margin-top: 10px;
    }
    .goods-item:nth-child(-n + 2) {
      margin-top: 0;
    }
  }
  .showType-scroll {
    width: 100%;
    overflow-x: scroll;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    padding: 0 5px;
    .goods-item {
      margin: 0 5px;
      width: 144px;
      height: 268px;

      .img {
        width: 144px;
        height: 144px;
        border-radius: 10px 10px 0px 0px;
      }
      .goods-info {
        padding: 8px 10px;
        .price {
          margin-top: 5px;
        }
        .sum-price {
          font-size: 11px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #cccccc;
        }
      }
    }
    .goods-item:last-child {
      margin-right: 5px;
    }
  }
  .topSpace-medium {
    padding-top: 10px;
  }
  .topSpace-big {
    padding-top: 15px;
  }
  .bottomSpace-medium {
    padding-bottom: 10px;
  }
  .bottomSpace-big {
    padding-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/customize/customizedComponents/Goods.vue